export default __webpack_public_path__ + "static/N0055-8541fd704d230f47f0204739836e2d0a.png";